<template>

  <div id="item">

    <PageTitle :title="$to(item.name)" v-if="item">
      <button class="save btn btn-primary" @click="save" v-if="$store.getters.loggedUserCanSaveInventory">{{$t("save")}}</button>
    </PageTitle>

    <div class="container">

      <Tabs ref="tabs">
        <TabSection :title="$t('items.information')" v-if="item">
          <div class="columns">
            <div class="column">
              <div class="group">
                <LocalizedInput :max-size="60" :title="$t('items.name')" :translate="item.name"/>
              </div>
              <div class="group">
                <LocalizedInput textarea :max-size="300" :title="$t('items.description')" :translate="item.description" inputClass="editable-description"/>
              </div>
              <div class="group" v-if="item.kitchen && item.kitchen.description">
                <LocalizedInput :max-size="20" :title="$t('items.kitchen_description')" :translate="item.kitchen.description"/>
              </div>
              <div class="group" v-if="variants.length === 0">
                <label>
                  <span>{{$t("items.tags")}}</span>
                  <Tooltip :text="$t('items.choose_tag')"/>
                </label>
                <MultiSelect :selected="item.tags" :options="tags" track-by-attribute="id" label="name"
                             @changed="item.tags = $event"/>
              </div>
              <div class="group">
                <label>
                  <span>{{$t('note')}} ({{item.note ? item.note.length : 0}}/{{noteMaxLength}})</span>
                  <Tooltip :text="$t('note_tooltip')"></Tooltip>
                </label>
                <input type="text" v-model="item.note" :maxlength="noteMaxLength">
              </div>
              <InventoryUsagePanel v-if="$route.query.item" type="item" :id="$route.query.item" preload></InventoryUsagePanel>
            </div>
            <div class="column">
              <div class="group">
                <ImageUpload :object="item.image" identifier="itemImageUpload" @changed="item.image = $event" :maxSizeInMb="0.8"></ImageUpload>
              </div>
            </div>
          </div>
        </TabSection>

        <TabSection :title="$t('items.menuboard_config')" v-if="item && item.menuboard && $store.state.loggedUser.isSuperAdmin">
          <div class="columns">
            <div class="column">
              <div class="group">
                <LocalizedInput :title="$t('items.name')" :translate="item.menuboard.name"/>
              </div>
              <div class="group">
                <label>{{$t("items.promo_price")}} ({{currencySymbol}})</label>
                <input type="number" v-model="item.menuboard.promoPrice">
              </div>
            </div>
            <div class="column">
              <div class="group">
                <LocalizedInput :title="$t('items.description')" :translate="item.menuboard.description"/>
              </div>
            </div>
          </div>
        </TabSection>

        <TabSection :title="$t('items.classification')" v-if="categories.length > 0 && item">
          <div class="columns">
            <div class="column">
              <div class="group">
                <label>
                  <span>{{$t("items.categories")}}</span>
                  <Tooltip :text="$t('items.choose_category')"/>
                </label>
                <MultiSelect :selected="item.categories" :options="categories"
                             :disabled="hiddenProduct" track-by-attribute="id" label="name"
                             @changed="item.categories = $event"/>
              </div>

              <div class="group hidden-product">
                <input id="chkHidden" type="checkbox" v-model="hiddenProduct" @change="removeCategories">
                <label for="chkHidden">
                  {{$t('items.hide_product')}}
                  <Tooltip :text="$t('items.hide_product_why')"/>
                </label>
              </div>

              <div class="group" v-if="item.categories.length">
                <div style="margin: 10px 0"><b>{{ $t("catalogs.availability") }}</b></div>
                <div class="group" v-for="c of item.categories">
                  <label>{{$to(c.name)}}</label>
                  <MultiSelect :options="catalogs" :selected="c.catalogs" label="name" @changed="c.catalogs = $event"/>
                </div>
              </div>

            </div>
            <!-- <div class="column">
              <div class="group">
                <label>
                  <span>{{$t('items.availability')}}</span>
                  <Tooltip :text="$t('items.availability_tooltip')"></Tooltip>
                </label>
                <div class="service">
                  <span class="service-name">{{$t('items.online_ordering')}}</span>
                  <select>
                    <option :value="true">{{$t('yes')}}</option>
                    <option :value="false">{{$t('no')}}</option>
                  </select>
                </div>
                <div class="service">
                  <span class="service-name">{{$t('items.kiosk')}}</span>
                  <select>
                    <option :value="true">{{$t('yes')}}</option>
                    <option :value="false">{{$t('no')}}</option>
                  </select>
                </div>
                <div class="service">
                  <span class="service-name">{{$t('items.menuboard')}}</span>
                  <select>
                    <option :value="true">{{$t('yes')}}</option>
                    <option :value="false">{{$t('no')}}</option>
                  </select>
                </div>
              </div>
            </div> -->
          </div>
        </TabSection>

        <TabSection :title="$t('items.payment_information')" v-if="item">
          <div class="columns">
            <div class="column">
              <div class="group">
                <label>{{$t('items.taxable')}}</label>
                <select v-model="item.taxable">
                  <option :value="true">{{$t('yes')}}</option>
                  <option :value="false">{{$t('no')}}</option>
                </select>
              </div>
              <div class="group" v-if="variants.length === 0 && ready">
                <label>{{$t('items.out_of_stock')}}</label>
                <select v-model="item.outOfStock" class="editable-outOfStock">
                  <option :value="true">{{$t('yes')}}</option>
                  <option :value="false">{{$t('no')}}</option>
                </select>
              </div>
              <div class="group">
                <label>{{$t('items.quantifiable')}}</label>
                <select v-model="item.quantifiable">
                  <option :value="true">{{$t('yes')}}</option>
                  <option :value="false">{{$t('no')}}</option>
                </select>
              </div>
              <!--
              <div class="group" v-if="variants.length === 0">
                <label>{{$t('items.promotions_applicable')}}</label>
                <select v-model="item.promotionsApplicable">
                  <option :value="true">{{$t('yes')}}</option>
                  <option :value="false">{{$t('no')}}</option>
                </select>
              </div>
              -->
              <div class="group" v-if="cateringActivated">
                <label>{{$t('items.minimum_catering')}}</label>
                <input type="number" min="0" v-model="item.minimumCatering">
              </div>
              <div class="group">
                <label>{{$t('items.minimum')}}</label>
                <input type="number" min="0" v-model="item.minimum">
              </div>
              <div class="group">
                <label>{{$t('items.maximum')}}</label>
                <input type="number" min="0" v-model="item.maximum">
              </div>
            </div>
            <div class="column">
              <div class="group" v-if="variants.length === 0 && ready">
                <TipsExternalId/>
                <label>{{$t('items.external_id')}}</label>
                <ExternalIDInput v-if="inventory" v-model="item.externalId" :inventory="inventory.id" :sync-item="item"
                                 input-class="editable-externalId"/>
              </div>
              <div class="group" v-if="variants.length === 0 && ready" >
                <label>{{$t('items.upc')}}</label>
                <input type="number" v-model="item.upc">
              </div>
              <div class="group" v-if="isKioskActivated && variants.length === 0 && ready">
                <TipBox class="upc-tip" warning v-if="item.priceEncodedInUpc">
                  <span v-html="$t('items.weight_based_upc_tip')"></span>
                  <router-link :to="{ path: '/settings/services/kiosk', query: { branch: $route.query.branch, company: $route.query.company }}">
                    {{$t('items.weight_based_upc_link')}}
                  </router-link>
                </TipBox>
                <label>{{$t('items.is_weight_based_scan_code')}}</label>
                <select v-model="item.priceEncodedInUpc">
                  <option :value="true">{{$t('yes')}}</option>
                  <option :value="false">{{$t('no')}}</option>
                </select>
              </div>
              <div class="group" v-if="isKioskActivated && variants.length === 0 && ready">
                <label>{{$t('items.available_for_scan_only')}}</label>
                <select v-model="item.availableForScanOnly">
                  <option :value="true">{{$t('yes')}}</option>
                  <option :value="false">{{$t('no')}}</option>
                </select>
              </div>
              <div class="group" v-if="variants.length === 0 && $store.getters.loggedUserHasSuperAdmin && ready">
                <label>{{$t('items.external_rules')}}</label>
                <input type="text" v-model="item.externalRules" >
              </div>
              <div class="group" v-if="variants.length !== 0 && ready">
                <label>{{$t('items.out_of_stock')}}</label>
                <select class="editable-outOfStock" v-model="item.outOfStock">
                  <option :value="true">{{$t('yes')}}</option>
                  <option :value="false">{{$t('no')}}</option>
                </select>
              </div>
            </div>
          </div>
        </TabSection>

        <TabSection :title="$t('items.prices_configuration')" v-if="item && variants.length === 0 && ready">
          <ItemPrices :item="item" :validate="$validate" root-item showFreeItemWarning/>
        </TabSection>

        <TabSection :title="$t('items.modifiers_combos')" v-if="variants.length === 0 && item && item.modifiers && item.modifierGroups
                && item.choices && item.choiceGroups">
          <div class="tabs">
            <span class="tab" @click="setActiveTab(item, 1)" :class="{active: item.activeTab === 1}">{{$t("inventory.modifiers")}}</span>
            <span class="tab" @click="setActiveTab(item, 2)" :class="{active: item.activeTab === 2}">{{$t("inventory.modifiers_groups")}}</span>
            <span class="tab" @click="setActiveTab(item, 3)" :class="{active: item.activeTab === 3}">{{$t("inventory.choices")}}</span>
            <span class="tab" @click="setActiveTab(item, 4)" :class="{active: item.activeTab === 4}">{{$t("inventory.choice_groups")}}</span>
          </div>

          <div class="tab-content" v-if="item.activeTab === 1">
            <ListMultiSelect :bank="modifiers" :bankTitle="$t('items.modifier_bank')" @changed="item = validateItemsForDisplay(item)"
                             :selected="item.formattedModifiers" :selectedTitle="$t('items.selected_modifiers')"/>
            <button class="btn btn-primary" @click="$modal.show('add-modifier')" v-if="$store.getters.loggedUserCanModifyInventory">{{$t("items.add_modifier")}}</button>
          </div>
          <div class="tab-content" v-if="item.activeTab === 2">
            <ListMultiSelect :bank="modifierGroups" :bankTitle="$t('items.modifier_group_bank')" @changed="item = validateItemsForDisplay(item)"
                             :selected="item.formattedModifierGroups" :selectedTitle="$t('items.selected_modifier_groups')"/>
            <!--<button class="btn btn-primary" @click="$modal.show('add-modifier-group')">{{$t("items.add_modifier_group")}}</button>-->
          </div>
          <div class="tab-content" v-if="item.activeTab === 3">
            <ListMultiSelect :bank="choices" :bankTitle="$t('items.choice_bank')" @changed="item = validateItemsForDisplay(item)"
                             :selected="item.formattedChoices" :selectedTitle="$t('items.selected_choices')"/>
            <!--<button class="btn btn-primary" @click="$modal.show('add-choice')">{{$t("items.add_choice")}}</button>-->
          </div>
          <div class="tab-content" v-if="item.activeTab === 4">
            <ListMultiSelect :bank="choiceGroups" :bankTitle="$t('items.choice_group_bank')" @changed="item = validateItemsForDisplay(item)"
                             :selected="item.formattedChoiceGroups" :selectedTitle="$t('items.selected_choice_groups')"/>
            <!--<button class="btn btn-primary" @click="$modal.show('add-choice-group')">{{$t("items.add_choice_group")}}</button>-->
          </div>
        </TabSection>

        <TabSection :title="$t('items.flow.configure_display')" v-if="item && item.flow && (!variants || variants.length === 0)">
          <div class="text">{{$t('items.flow.configure_drag_and_drop')}}</div>
          <div class="display-items">
            <Draggable v-model="item.flow.items" @start="drag = true" @end="drag = false" @change="item = flowChanged(item)">
              <div class="display-item" v-for="flowItem in item.flow.items">
                <div class="icon">
                  <svgicon src="icon/hamburger.svg" :height="12" :width="12"></svgicon>
                </div>
                <div v-if="flowItem.name" class="names">{{$to(flowItem.name)}}</div>
                <div class="names" v-if="flowItem.names">
                  <span class="name" v-for="name of flowItem.names">{{$to(name)}}</span>
                </div>
                <Tag>{{$t('items.flow.' + flowItem.type)}}</Tag>
              </div>
            </Draggable>
          </div>
        </TabSection>

        <TabSection ref="variantTab" :title="$t('items.variants')" v-if="item && variants">
          <div id="variants" class="variants tabs" v-if="variants.length > 0">
            <Draggable v-model="variants" @start="drag=true" @end="drag=false">
              <div class="tab" v-for="(variant,variantIndex) in variants" :key="variantIndex"
                   @click="setActiveVariant(variantIndex)"
                   :class="{active: activeVariant === variantIndex}">
              <span>
                #{{variantIndex + 1}} <span v-if="variant.name.fr">&ndash;</span> {{variant.name.fr}}
              </span>
              </div>
            </Draggable>
          </div>

          <div class="no-variant" v-if="variants.length === 0">{{$t('items.no_variant')}}</div>
          <div class="variant" v-for="(variant,variantIndex) in variants" :key="variantIndex" v-if="activeVariant === variantIndex">
            <div class="variantTitle">
              <span>{{$t('items.variant')}} #{{variantIndex+1}}</span>
              <button class="btn btn-primary remove" @click="removeVariant(variantIndex)" v-if="$store.getters.loggedUserCanModifyInventory">
                <svgicon src="/icon/close.svg" height="15" width="15"/>
              </button>
            </div>
            <div class="subtitle">{{$t('items.information')}}</div>
            <div class="columns">
              <div class="column">
                <div class="group">
                  <LocalizedInput :title="$t('items.name')" :translate="variant.name"/>
                </div>
                <div class="group">
                  <LocalizedInput textarea :title="$t('items.description')" :translate="variant.description"/>
                </div>
                <div class="group" v-if="variant.kitchen && variant.kitchen.description">
                  <LocalizedInput :max-size="20" :title="$t('items.kitchen_description')" :translate="variant.kitchen.description"/>
                </div>
                <div class="group">
                  <label>
                    <span>{{$t("items.tags")}}</span>
                    <Tooltip :text="$t('items.choose_tag')"/>
                  </label>
                  <MultiSelect :selected="variant.tags" :options="tags" track-by-attribute="id" label="name"
                               @changed="variant.tags = $event"/>
                </div>
              </div>
              <div class="column">
                <div class="group">
                  <ImageUpload :identifier="'variantImageUpload' + variant.id" :object="variant.image" @changed="variant.image = $event" :maxSizeInMb="0.8"></ImageUpload>
                </div>
              </div>
            </div>
            <div class="subtitle">{{$t('items.payment_information')}}</div>
            <div class="columns">
              <div class="column">
                <div class="group">
                  <label>{{$t('items.out_of_stock')}}</label>
                  <select v-model="variant.outOfStock" class="editable-outOfStock">
                    <option :value="true">{{$t('yes')}}</option>
                    <option :value="false">{{$t('no')}}</option>
                  </select>
                </div>
                <div class="group">
                  <TipsExternalId/>
                  <label>{{$t('items.external_id')}}</label>
                  <ExternalIDInput v-if="inventory" v-model="variant.externalId" :inventory="inventory.id"
                                   :sync-item="variant" input-class="editable-externalId"/>
                </div>
                <div class="group" v-if="cateringActivated">
                  <label>{{$t('items.minimum_catering')}}</label>
                  <input type="number" v-model="variant.minimumCatering">
                </div>
              </div>
              <div class="column">
                <div class="group">
                  <label>{{$t('items.upc')}}</label>
                  <input type="number" v-model="variant.upc">
                </div>
                <div class="group" v-if="isKioskActivated">
                  <TipBox class="upc-tip" warning v-if="variant.priceEncodedInUpc">
                    <span v-html="$t('items.weight_based_upc_tip')"></span>
                    <router-link :to="{ path: '/settings/services/kiosk', query: { branch: $route.query.branch, company: $route.query.company }}">
                      {{$t('items.weight_based_upc_link')}}
                    </router-link>
                  </TipBox>
                  <label>{{$t('items.is_weight_based_scan_code')}}</label>
                  <select v-model="variant.priceEncodedInUpc">
                    <option :value="true">{{$t('yes')}}</option>
                    <option :value="false">{{$t('no')}}</option>
                  </select>
                </div>
                <div class="group" v-if="isKioskActivated">
                  <label>{{$t('items.available_for_scan_only')}}</label>
                  <select v-model="variant.availableForScanOnly">
                    <option :value="true">{{$t('yes')}}</option>
                    <option :value="false">{{$t('no')}}</option>
                  </select>
                </div>
                <div class="group" v-if="$store.getters.loggedUserHasSuperAdmin" >
                  <label>{{$t('items.external_rules')}}</label>
                  <input type="text" v-model="variant.externalRules">
                </div>
              </div>
            </div>

            <Panel :title="$t('items.prices_configuration')" collapsible>
              <ItemPrices :item="variant" :validate="$validate" showFreeItemWarning
                          :priceSchemeValidationRootName="'variants[' + variantIndex + ']'"></ItemPrices>
            </Panel>

            <Panel :title="$t('items.modifiers_combos')"
                   v-if="variant && variant.formattedModifiers && variant.formattedModifierGroups && variant.formattedChoices && variant.formattedChoiceGroups" collapsible collapsed>
              <div class="tabs">
                <span class="tab" @click="setActiveTab(variant, 1)" :class="{active: variant.activeTab === 1}">{{$t("inventory.modifiers")}}</span>
                <span class="tab" @click="setActiveTab(variant, 2)" :class="{active: variant.activeTab === 2}">{{$t("inventory.modifiers_groups")}}</span>
                <span class="tab" @click="setActiveTab(variant, 3)" :class="{active: variant.activeTab === 3}">{{$t("inventory.choices")}}</span>
                <span class="tab" @click="setActiveTab(variant, 4)" :class="{active: variant.activeTab === 4}">{{$t("inventory.choice_groups")}}</span>
              </div>

              <div class="tab-content" v-if="variant.activeTab === 1">
                <ListMultiSelect :bank="modifiers" :bankTitle="$t('items.modifier_bank')" @changed="validateItemsForDisplay(variant)"
                                 :selected="variant.formattedModifiers" :selectedTitle="$t('items.selected_modifiers')"/>
                <button class="btn btn-primary" @click="$modal.show('add-modifier')" v-if="$store.getters.loggedUserCanModifyInventory">{{$t("items.add_modifier")}}</button>
              </div>
              <div class="tab-content" v-if="variant.activeTab === 2">
                <ListMultiSelect :bank="modifierGroups" :bankTitle="$t('items.modifier_group_bank')" @changed="validateItemsForDisplay(variant)"
                                 :selected="variant.formattedModifierGroups" :selectedTitle="$t('items.selected_modifier_groups')"/>
                <!--<button class="btn btn-primary" @click="$modal.show('add-modifier-group')">{{$t("items.add_modifier_group")}}</button>-->
              </div>
              <div class="tab-content" v-if="variant.activeTab === 3">
                <ListMultiSelect :bank="choices" :bankTitle="$t('items.choice_bank')" @changed="validateItemsForDisplay(variant)"
                                 :selected="variant.formattedChoices" :selectedTitle="$t('items.selected_choices')"/>
                <!--<button class="btn btn-primary" @click="$modal.show('add-choice')">{{$t("items.add_choice")}}</button>-->
              </div>
              <div class="tab-content" v-if="variant.activeTab === 4">
                <ListMultiSelect :bank="choiceGroups" :bankTitle="$t('items.choice_group_bank')" @changed="validateItemsForDisplay(variant)"
                                 :selected="variant.formattedChoiceGroups" :selectedTitle="$t('items.selected_choice_groups')"/>
                <!--<button class="btn btn-primary" @click="$modal.show('add-choice-group')">{{$t("items.add_choice_group")}}</button>-->
              </div>
            </Panel>

            <Panel :title="$t('items.menuboard_config')"
                   v-if="variant.menuboard && $store.state.loggedUser.isSuperAdmin /*&& company && company.menuBoard.activated*/" collapsible collapsed>
              <div class="columns">
                <div class="column">
                  <div class="group">
                    <LocalizedInput :title="$t('items.name')" :translate="variant.menuboard.name"/>
                  </div>
                  <div class="group">
                    <label>{{$t("items.promo_price")}} ({{currencySymbol}})</label>
                    <input type="number" v-model="variant.menuboard.promoPrice">
                  </div>
                </div>
                <div class="column">
                  <div class="group">
                    <LocalizedInput :title="$t('items.description')" :translate="variant.menuboard.description"/>
                  </div>
                </div>
              </div>
            </Panel>

            <Panel :title="$t('items.flow.configure_display')" v-if="variant.flow" collapsible collapsed>
              <div class="text">{{$t('items.flow.configure_drag_and_drop')}}</div>
              <div class="display-items">
                <Draggable v-model="variant.flow.items" @start="drag = true" @end="drag = false" @change="variant = flowChanged(variant)">
                  <div class="display-item" v-for="item in variant.flow.items">
                    <div class="icon">
                      <svgicon src="icon/hamburger.svg" :height="12" :width="12"></svgicon>
                    </div>
                    <div v-if="item.name" class="names">{{$to(item.name)}}</div>
                    <div class="names" v-if="item.names">
                      <span class="name" v-for="name of item.names">{{$to(name)}}</span>
                    </div>
                    <Tag>{{$t('items.flow.' + item.type)}}</Tag>
                  </div>
                </Draggable>
              </div>
            </Panel>

          </div>
          <div>
            <button class="btn btn-primary" @click="addVariant" v-if="$store.getters.loggedUserCanModifyInventory">{{$t('items.add_variant')}}</button>
          </div>
        </TabSection>

        <TabSection :title="$t('cross_sell.title')" v-if="item && isPosActivated">
          <CrossSell :item="item" @addSuggestion="addSuggestionToCrossSells"
                     @setSuggestionItem="setCrossSellSuggestionItem" @setSuggestionText="setCrossSellSuggestionText"
                     @removeSuggestion="removeCrossSellSuggestion" :validate="$validate"/>
        </TabSection>
      </Tabs>

      <div class="footer-actions">
        <button class="btn btn-primary" @click="save" v-if="$store.getters.loggedUserCanSaveInventory">{{$t("save")}}</button>
      </div>

    </div>

    <AddModifierModal @created="modifiers.push($event)"/>
    <AddChoiceModal @created="choices.push($event)"/>

  </div>

</template>

<script>
  import Vue from 'vue';
  import ListMultiSelect from '@/components/tools/ListMultiSelect.vue';
  import MultiSelect from '@/components/tools/MultiSelect.vue';
  import Tooltip from '@/components/tools/Tooltip.vue';
  import AddModifierModal from "@/components/modifiers/addModifierModal.vue";
  import AddChoiceModal from "@/components/choices/addChoiceModal.vue";
  import { mapActions } from "vuex";
  import Draggable from 'vuedraggable';
  import ItemPrices from "@/components/inventory/ItemPrices.vue";
  import CrossSell from "@/components/qsr/CrossSell.vue";
  import LocalizedInput from "@/components/tools/LocalizedInput";
  import ImageUpload from "@/components/tools/ImageUpload.vue"
  import Tag from "@/components/tools/Tag.vue";
  import PageTitle from "@/components/PageTitle";
  import ExternalIDInput from "@/components/inventory/ExternalIDInput";
  import {initPropertyOfMultiSelect, assignIdsOfMultiSelect} from "@/vueUtils";
  import TipsExternalId from "@/components/tips/TipsExternalId.vue";

  export default {

    name: 'item',

    components: {
      Tooltip, ListMultiSelect, MultiSelect, CrossSell,
      AddModifierModal, AddChoiceModal, LocalizedInput,
      Tag, ImageUpload, Draggable, PageTitle, ItemPrices,
      ExternalIDInput, TipsExternalId
    },

    data() {
      return {
        noteMaxLength: 16,
        itemId: null,
        inventory: null,
        item: null,
        hiddenProduct: false,
        categories: [],
        tags: [],
        modifiers: [],
        modifierGroups: [],
        choices: [],
        choiceGroups: [],
        variants: [],
        catalogs: [],
        companyModules: null,
        branchModules: null,
        activeVariant: 0,
        currencySymbol: '$',
        ready: false,
      }
    },

    computed: {
      company() {
        return this.$store.state.contextCompany;
      },
      version() {
        return this.$store.state.contextVersion;
      },
      versionId() {
        return this.version ? this.version.id : null
      },
      canDisplayFreeItems() {
        return this.$store.state.contextInventory && this.$store.state.contextInventory.showItemsWhenZero;
      },
      isKioskActivated() {
        if (this.$route.query.company) {
          return this.companyModules && this.companyModules.kiosk;
        }
        return this.branchModules && this.branchModules.kiosk;
      },
      inventoryReference() {
        return this.company ? this.company.nameCanonical : this.inventory.id;
      },
      cateringActivated() {
        return this.inventory && this.inventory.deliveryMethods.includes('catering');
      },
      isMenuboardActivated() {
        return this.companyModules && this.companyModules.menuBoard;
      },
      isPosActivated() {
        return this.companyModules && this.companyModules.POS;
      }
    },

    validate: {
      "item.priceSchemes": {
        array: true,
        elements: {
          unitPrice: {
            maxDecimals: 2
          }
        }
      },
      "variants": {
        array: true,
        elements: {
          "priceSchemes": {
            array: true,
            elements: {
              unitPrice: {
                required: true,
                maxDecimals: 2
              }
            }
          }
        }
      },
      "item.crossSells": {
        array: true,
        elements: {
          "text.->.fr": {
            maxLength: 100
          },
          "text.->.en": {
            maxLength: 100
          }
        }
      }
    },

    async mounted() {
      this.$store.commit('showSpinner', true);
      this.$store.state.pageTitleTranslationKey = "menu";
      this.$store.state.pageIcon = "/icon/menu.svg";

      this.itemId = this.$route.query.item;
      this.inventory = await this.$store.getters.getContextInventory;
      this.currencySymbol = await this.$store.getters.getContextCurrencySymbol;
      this.companyModules = await this.$store.getters.getContextCompanyActivatedModule;
      this.branchModules = await this.$store.getters.getContextBranchActivatedModule;

      let responses = await Promise.all([
        this.getCategories({inventoryId: this.inventoryReference, augment: 'short'}),
        this.getManyInventoryEntity({inventory: this.inventoryReference, augment: 'short', entity: "tags"}),
        this.getModifiers({inventoryId: this.inventoryReference, augment: 'short'}),
        this.getModifierGroups({inventoryId: this.inventoryReference, augment: 'short'}),
        this.getChoices({inventoryId: this.inventoryReference, augment: 'short'}),
        this.getChoiceGroups({inventoryId: this.inventoryReference, augment: 'short'}),
        this.getCatalogs({inventoryId: this.inventoryReference, augment: 'short'})
      ]);

      for (let [rIndex, response] of responses.entries()) {
        if (!response) {
          console.log(`erreur de fetch sur le l'appel '${rIndex}'`);
          toast(this.$t("error.no_server"), "error");
        }
      }
      this.categories = responses[0];
      this.tags = responses[1];
      this.modifiers = responses[2];
      this.modifierGroups = responses[3];
      this.choices = responses[4];
      this.choiceGroups = responses[5];
      this.catalogs = responses[6];

      if (this.catalogs) {
        this.catalogs = this.catalogs
            .filter(c => c.linked.length)
            .map(c => ({id: c.id, name: c.linked[0]}));
      }
      for (let c of this.categories) {
        Vue.set(c, 'catalogs', this.catalogs)
      }

      if (this.itemId) {
        await this.loadItem();
        await this.loadItemVariants();
      } else {
        this.item = this.emptyItem();
      }

      this.item = this.validateItemsForDisplay(this.item);
      this.item.flow.initialItems = this._formatInitialFlowItems(this.item);
      this.$store.commit('showSpinner', false);

      this.ready = true;
      this.lockAllFields();
    },

    watch: {
      version: async function () {
        if (this.itemId) {
          showSpinner();
          await this.loadItem();
          hideSpinner();
        }
      },
      variants() {
        if (this.variants.length > 0) {
          this.item.tags = [];
        }
      },
      "$store.getters.isBranchContextInventory"(newValue) {
        if (newValue) {
          window.lockFields(this.$store.getters.getOverloadableFields);
        }
      }
    },

    methods: {

      ...mapActions([
        "getCategories",
        "getManyInventoryEntity",
        "getItem", "saveItem", "createItem",
        "getVariants",
        "getImage", "saveImage",
        "getModifiers", "getModifierGroups",
        "getChoices", "getChoiceGroups",
        "getCatalogs", "getItemToCategories"
      ]),

      lockAllFields() {
        if (this.$store.getters.isBranchContextInventory) {
          window.lockFields(this.$store.getters.getOverloadableFields);
        } else if (!this.$store.getters.loggedUserCanModifyInventory) {
          window.lockFields();
        }
      },

      setActiveVariant(variantIndex) {
        this.activeVariant = variantIndex;
        this.$nextTick(() => {
          this.lockAllFields();
        });
      },

      productHasNoPrice(obj) {
        return obj.priceSchemes.filter(p => parseFloat(p.unitPrice) > 0).length === 0;
      },

      async loadItem() {
        let version = this.versionId
        let item = await this.getItem({ itemId: this.itemId, inventoryId: this.inventoryReference, version });
        if (!item) {
          toast(this.$t("error.no_server"), "error");
          return;
        }
        if (item.image) {
          item.image = await this.getImage({inventoryId: this.inventoryReference, imageId: item.image});
        }

        let itcs = await this.getItemToCategories({inventoryId: this.inventoryReference, item: this.itemId, augment: 'catalogs'});
        if (itcs) {
          for (let c of this.categories) {
            let itc = itcs.find(itc => itc.category === c.id);
            c.catalogs = itc
                ? this.catalogs.filter(c => itc.catalogs.includes(c.id))
                : this.catalogs
          }
        }
        this.fixItemForForm(item);
        this.item = item;
        this.$forceUpdate();
      },

      fixItemForForm(item) {
        item.name = !item.name || Array.isArray(item.name) ? {} : item.name;
        item.description = !item.description || Array.isArray(item.description) ? {} : item.description;
        item.externalRules = item.externalRules ? JSON.stringify(item.externalRules) : JSON.stringify({});
        item.activeTab = 1;

        item.menuboard = item.menuboard || {};
        item.menuboard.name = item.menuboard.name || { fr: "", en : "" };
        item.menuboard.description = item.menuboard.description || { fr: "", en : "" };
        item.menuboard.promoPrice = item.menuboard.promoPrice || null;

        item.kitchen = item.kitchen || {};
        item.kitchen.description = item.kitchen.description || { fr: "", en : "" };
        item.kitchen.recipe = item.kitchen.recipe || { fr: "", en: "" };
        item.kitchen.ingredient = item.kitchen.ingredient || { fr: "", en: "" };
        item.kitchen.allergens = item.kitchen.allergens || { fr: "", en: "" };

        item.crossSells = item.crossSells || []
        item.crossSells = item.crossSells.map(c => ({ ...c, tempId: this.randomInt() }));

        initPropertyOfMultiSelect(item, 'modifiers', 'formattedModifiers', this.modifiers)
        initPropertyOfMultiSelect(item, 'modifierGroups', 'formattedModifierGroups', this.modifierGroups)
        initPropertyOfMultiSelect(item, 'choices', 'formattedChoices', this.choices)
        initPropertyOfMultiSelect(item, 'choiceGroups', 'formattedChoiceGroups', this.choiceGroups)
        initPropertyOfMultiSelect(item, 'tags', 'tags', this.tags)
        initPropertyOfMultiSelect(item, 'categories', 'categories', this.categories)
      },

      emptyItem(opt = {}) {
        let item = {
          name: { fr: "", en: "" },
          description: { fr: "", en: "" },
          categories: [],
          tags: [],
          choiceGroups: [],
          choices: [],
          externalId: null,
          upc: null,
          availableForScanOnly: false,
          externalRules: "{}",
          image: null,
          menuboard: null,
          kitchen: null,
          flow: null,
          modifierGroups: [],
          modifiers: [],
          minimum: null,
          maximum: null,
          outOfStock: false,
          priceSchemes: (this.inventory.allSchemeMethods || this.inventory.deliveryMethods).map(method => ({method, unitPrice: null})),
          promotionsApplicable: true,
          quantifiable: true,
          taxable: true,
          minimumCatering: null,
          variants: [],
          activeTab: 1,
          crossSells: [],
          revenueCenter: {
            prices: {}
          }
        }
        if (opt.type === 'variant') {
          item.revenueCenter = {
            prices: {}
          };
          delete item.categories;
          delete item.variants;
          delete item.crossSells;
          delete item.image;
          delete item.flow;
          delete item.upc;
          delete item.maximum;
          delete item.minimum;
          delete item.minimumCatering;
          delete item.promotionsApplicable;
          delete item.quantifiable;
          delete item.taxable;
        }

        this.fixItemForForm(item);
        return item;
      },

      async loadItemVariants() {
        if (this.item.variants.length > 0) {
          this.variants = await this.getVariants({inventoryId: this.inventoryReference, id: this.item.variants});
          for (let variant of this.variants) {
            if (variant.image) {
              variant.image = await this.getImage({inventoryId: this.inventoryReference, imageId: variant.image});
            }
            this.fixItemForForm(variant);
            this.validateItemsForDisplay(variant);
            variant.flow.initialItems = this._formatInitialFlowItems(variant);
          }
          if (this.$route.query.variant) {
            let variantId = parseInt(this.$route.query.variant);
            let index = this.variants.indexOf(this.variants.find(v => v.id === variantId));
            if (index > -1) {
              this.setActiveVariant(index);
              this.$refs.tabs.setActive(this.$refs.variantTab);
            }
          }
        }
      },

      itemsForDisplay(item) {
        let items = [];

        if (item.formattedChoiceGroups) {
          items.push(...item.formattedChoiceGroups.map(g => {
            return {
              id: g.id,
              name: g.name,
              type: 'choice-group'
            }
          }));
        }
        if (item.formattedChoices) {
          items.push(...item.formattedChoices.map(g => {
            return {
              id: g.id,
              name: g.name,
              type: 'choice'
            }
          }));
        }
        if (item.formattedModifierGroups) {
          items.push(...item.formattedModifierGroups.map(g => {
            return {
              id: g.id,
              name: g.name,
              type: 'modifier-group'
            }
          }));
        }
        if (item.formattedModifiers && item.formattedModifiers.length > 0) {
          items.push({
            id: null,
            names: item.formattedModifiers.map(m => m.name),
            type: 'modifiers'
          })
        }

        return items;
      },

      validateItemsForDisplay(item) {
        item.itemsForDisplay = this.itemsForDisplay(item);
        if (!item.flow) {
          item.flow = {items: [], wasEmpty: true};
        }
        for (let itemForDisplay of item.itemsForDisplay) {
          let found = item.flow.items.find(i => i.type === itemForDisplay.type && i.id === itemForDisplay.id);
          if (!found) {
            item.flow.items.push(itemForDisplay);
          }
        }
        for (let flowItem of item.flow.items) {
          let found = item.itemsForDisplay.find(i => i.type === flowItem.type && i.id === flowItem.id);
          if (!found) {
            item.flow.items.splice(item.flow.items.indexOf(flowItem), 1);
          }
        }

        return item;
      },

      flowChanged(item) {
        item.flow.changed = true;
        return item;
      },

      addVariant() {
        let variant = this.emptyItem({type: 'variant'});
        variant.priceSchemes = JSON.parse(JSON.stringify(this.item.priceSchemes));
        this.variants.push(variant);

        toast(this.$t("items.success_variant"), "success");
        this.activeVariant =  this.variants.length - 1;
        document.getElementById("variants").scrollIntoView();
      },
      removeVariant(index) {
        this.variants.splice(index, 1);

        this.activeVariant--;
        if (this.activeVariant < 0) {
          this.activeVariant++;
        }
      },
      setActiveTab(obj, tab) {
        Vue.set(obj, 'activeTab', tab);
        this.$forceUpdate();
      },
      removeCategories() {
        if (this.hiddenProduct) {
          this.item.categories = [];
        }
      },

      async save() {
        if (!this.$validate.valid()) {
          toast(this.$t("branch.error.required"), "warning");
          this.$validate.validateAllOnce();
          return;
        }

        showSpinner();
        let version = this.versionId || undefined;
        let data = await this.getSerializedDataAndExecutePreSaveTasks();
        let response = this.itemId
            ? await this.saveItem({data, version, inventoryId: this.inventoryReference, itemId: this.itemId })
            : await this.createItem({data, version, inventoryId: this.inventoryReference})
        hideSpinner();

        if (!response) {
          toast(this.$t("error.no_server"), "error");
          return;
        }

        if (this.itemId) {
          this.item.variants = response.variants;
          await this.loadItemVariants();
          this.validateItemsForDisplay(this.item);
          this.item.flow.initialItems = this._formatInitialFlowItems(this.item);
          delete this.item.flow.changed;
        } else {
          this.$router.push(this.$router.buildContext("/item/edit", {item: response.id}));
        }

        toast(this.$t("items.success_item"), "success");
      },

      async getSerializedDataAndExecutePreSaveTasks() {
        let data = this.getSerializedData();
        await this._formatImageBeforeSave(data);
        for (let variant of data.variants) {
          await this._formatImageBeforeSave(variant);
        }
        return data;
      },

      getSerializedData() {
        let data = this._copy(this.item);

        data.crossSells = this._getFormattedCrossSellBeforeSave();
        data.externalRules = data.externalRules ? JSON.parse(data.externalRules) : JSON.stringify({});
        data.minimumCatering = data.minimumCatering || null;
        data.minimum = data.minimum ? parseFloat(data.minimum) : null;
        data.maximum = data.maximum ? parseFloat(data.maximum) : null;
        data.categories = data.categories.map(({id,catalogs}) => ({id, catalogs: catalogs.map(c => c.id) }));
        data.tags = data.tags.map(({id}) => id);

        assignIdsOfMultiSelect(data, 'modifiers', 'formattedModifiers');
        assignIdsOfMultiSelect(data, 'modifierGroups', 'formattedModifierGroups');
        assignIdsOfMultiSelect(data, 'choices', 'formattedChoices');
        assignIdsOfMultiSelect(data, 'choiceGroups', 'formattedChoiceGroups');
        this._formatFlow(data);
        delete data.activeTab;

        data.variants = this._copy(this.variants);
        let priority = 0;
        for (let variant of data.variants) {
          variant.externalRules = JSON.parse(variant.externalRules);
          variant.tags = variant.tags.map(({id}) => id)
          variant.priority = priority;

          assignIdsOfMultiSelect(variant, 'modifiers', 'formattedModifiers');
          assignIdsOfMultiSelect(variant, 'modifierGroups', 'formattedModifierGroups');
          assignIdsOfMultiSelect(variant, 'choices', 'formattedChoices');
          assignIdsOfMultiSelect(variant, 'choiceGroups', 'formattedChoiceGroups');
          delete variant.activeTab;
          this._formatFlow(variant);
          priority++;
        }
        return data;
      },

      _formatInitialFlowItems(item) {
        return JSON.stringify(item.flow.items.map(i => { return { id: i.id, type: i.type }}));
      },

      _formatFlow(obj) {
        if (!obj.flow || !obj.flow.items) {
          return;
        }
        if (!obj.flow.changed) {
          delete obj.flow;
        } else {
          delete obj.flow.initialItems;
          delete obj.flow.wasEmpty;
          delete obj.flow.changed;
        }
        delete obj.itemsForDisplay;
      },

      async _formatImageBeforeSave(obj) {
        if (obj.image && obj.image.url && obj.image.url.startsWith("data:")) {
          let image = await this.saveImage({inventoryId: this.inventoryReference, image: getImageData(obj.image)});
          obj.image = image ? image.id : null;
        } else if (obj.image && obj.image.id) {
          obj.image = obj.image.id;
        } else if (obj.image && obj.image.deleted) {
          obj.image = null;
        }
        return obj;
      },

      _copy(obj) {
        return JSON.parse(JSON.stringify(obj));
      },
      randomInt() {
        return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
      },
      addSuggestionToCrossSells() {
        this.item.crossSells.push({tempId: this.randomInt(), item: null, link: '<>', text: {} });
      },
      setCrossSellSuggestionItem(suggestionItemId, suggestionTempId) {
        let crossSellSuggestion = this.item.crossSells.find(c => c.tempId === suggestionTempId);
        crossSellSuggestion.item = suggestionItemId;
      },
      setCrossSellSuggestionText(suggestionText, suggestionTempId) {
        let crossSellSuggestion = this.item.crossSells.find(c => c.tempId === suggestionTempId);
        crossSellSuggestion.text['->'] = suggestionText;
        crossSellSuggestion.text['<-'] = suggestionText;
      },
      removeCrossSellSuggestion(suggestionTempId) {
        let index = this.item.crossSells.findIndex(c => c.tempId === suggestionTempId);
        this.item.crossSells.splice(index, 1);
      },
      _getFormattedCrossSellBeforeSave() {
        if (!this.isPosActivated) {
          return;
        }
        return this.item.crossSells
            .filter(c => !!c.item) //filter empty crossSell
            .map(({tempId, ...crossSell}) => crossSell) //remove tempId
      }
    },
  };

</script>


<style lang="scss" scoped>
  #item {
    display: flex;
    flex-direction: column;
  }

  .subtitle {
    &:not(:first-child) {
      margin-top: 10px;
    }
  }
  .listMultiSelect {
    margin-bottom: 30px;
  }
  .no-variant {
    font-style: italic;
    color: #808080;
    margin-bottom: 20px;
  }
  .hidden-product {
    padding-top: 15px;
    .tooltip {
      margin-left: 10px;
    }
  }
  .service {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    select {
      width: 150px;
    }
  }
  .service-name {
    flex-grow: 1;
    font-weight: bold;
  }
  .tab-content {
    margin-top: 30px;
  }
  .variant {
    border-bottom: 1px solid #f1f1f1;
    padding-bottom: 30px;
    margin-bottom: 30px;
  }
  .variantTitle {
    font-weight: bold;
    font-size: 18px;
    margin: 0 0 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .variants.tabs {
    & > div {
      width: 100%;
      display: flex;
    }
  }
  .variants.tabs {
    margin-bottom: 20px;
  }
  .remove {
    padding: 13px;
    .svgicon {
      fill: #fff;
    }
  }
  .text {
    margin-bottom: 20px;
  }
  .display-item {
    padding: 10px;
    border-radius: 5px;
    background-color: #f8f8f8;
    cursor: grab;
    font-size: 12px;
    border: 1px solid #e9e9e9;
    font-weight: 500;
    max-width: 700px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .icon {
      flex-shrink: 0;
      margin-right: 10px;
      fill: #c1c1c1;
    }

    .tag {
      margin-left: 10px;
      text-align: center;
      text-transform: none;
      font-weight: 500;
    }

    .names {
      display: flex;
      flex-wrap: wrap;
      flex-grow: 1;
    }

    .name {
      padding: 4px;
      border: 1px dashed #c1c1c1;
      border-radius: 3px;
      margin-right: 4px;
      margin-bottom: 2px;
    }

    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }

  .upc-tip {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 10px;
  }

  .--red {
    color: var(--secondary-color);
  }
</style>
